<template>
	<div>
    <FormUser
			:userEdit="userEdit"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormUser"
		></FormUser>

		<v-card class="mb-1">
      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-3">
        <v-toolbar-title class="d-none d-sm-block" :class="archive==false?null:'red--text'">Usuários</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>
        
        <v-text-field v-model="dataTable.search" append-icon="mdi-magnify" label="Filtrar" single-line hide-details></v-text-field>

      </v-toolbar>

      <!-- Toolbar -->
      <v-toolbar dense flat dark color="blue-grey darken-4">
        <v-spacer></v-spacer>
        <v-toolbar-title class="d-none d-sm-block">Ações</v-toolbar-title>
        <v-divider class="d-none d-sm-block mx-4" inset vertical></v-divider>

        <v-btn @click="formUser(0, null)" title="Cadastrar" icon color="green darken-1">
          <v-icon>fal fa-plus</v-icon>
        </v-btn>

        <v-btn title="Recarregar dados" icon @click="getData()" color="orange lighten-1">
          <v-icon>fal fa-repeat</v-icon>
        </v-btn>

        <v-btn :title="archive?'Mudar para ativos':'Mudar para arquivados'" icon @click="archive=!archive" :color="archive==false?'green':'red'">
          <v-icon>fal fa-archive</v-icon>
        </v-btn>

      </v-toolbar>
    </v-card>
    
    <!-- DataTable -->
		<DataTable :dados="users" :dataTable="dataTable">
      <template v-slot:actions="{item}">
        <div class="table-actions">
          <v-btn small class="mr-2 btn-square" title="Editar" @click="formUser(1, item)">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
          <v-btn small class="btn-square" title="Cursos" :to="{ name: 'UserCursos', params: { id: item.id } }">
            <v-icon small>fal fa-chalkboard-teacher</v-icon>
          </v-btn>
        </div>
			</template>
		</DataTable>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import DataTable from '@/components/DataTable'
import FormUser from '@/components/admin/FormUser'

export default {
  components: {
    DataTable,
    FormUser
  },
	data () {
    return {
      server: 'user',
			archive: false,
      users: [],
      dataTable: {
        headers: [
          {	text: 'ID', value: 'id' },
          { text: 'Nome', value: 'nome', align: 'start'},
          { text: 'CPF', value: 'cpf' },
          { text: 'E-mail', value: 'email' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Ações', value: 'actions', sortable: false }
        ],
        sortBy: 'nome',
        sortDesc: false,
        multiSort: false,
        search: '',
        loading: true,
      },
      showFormUser: false,
      userEdit: {},
		}
  },
  computed: {
    ...mapState(['user', 'XMLHttpRequest', 'searchUser']),
	},
	created() {
		this.getData()
  },
  watch: {
    archive(){ this.getData() },
    searchUser(val) {
			if (val === true) {
				this.getData()
			}
		},
  },
	methods: {
		getData() {
      this.dataTable.loading = true
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('archive', this.archive)
			let vd = this

			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
          vd.$store.dispatch('searchUser', { value: false })
					if (response.data.error === 0) {
            vd.users = response.data.users
            setTimeout(function(){ vd.dataTable.loading = false }, 1000)
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
    },
    formUser(type, user) {
			this.typeForm = type
			if (type === 0) {
				this.userEdit = {}
			} else {
        this.userEdit = Object.assign({}, user)
			}
			this.showFormUser = true
			setTimeout(() => {
				this.$store.dispatch('dialogUser', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			this.typeForm = value.typeForm
			if (value.hideForm == 'user') {
				this.showFormUser = false
			}
		},
	}
}
</script>
<style lang="css">
  .table-actions{
    min-width: 95px;
  }
</style>